// extracted by mini-css-extract-plugin
export default {"shortcutBubble":"ToolbarTooltip-module__MdzYO","shortcut":"ToolbarTooltip-module__dtEN7","shortcutKey":"ToolbarTooltip-module__DhS_c"};